import { cn } from "../lib/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Loading-Animation. `'pulse'` (Default) = bestehendes `animate-pulse bg-muted`
   * (keine Regression der ~23 Aufrufer). `'shimmer'` = DS Industrial-Shimmer
   * (TES-952/F5, `.skeleton-shimmer`-Gradient-Sweep ueber surface-container).
   */
  variant?: "pulse" | "shimmer";
}

function Skeleton({ className, variant = "pulse", ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        "rounded-md",
        variant === "shimmer" ? "skeleton-shimmer" : "animate-pulse bg-muted",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
